import { NonStaticContainer } from '@r1-frontend/ui-react/experimental/containers';
import { AdvertisingLabelWithTooltip } from '@r1-frontend/ui-react/organisms/AdvertisingLabelWithTooltip';

import * as PC from './styled';

export interface IPartnerProps {
    image: string,
    title: string,
    body: string,
    advertiserName: string,
    advertiserErid: string,
}

const PartnerCard = ({ image, title, body, advertiserName, advertiserErid }: IPartnerProps): JSX.Element => {
    return (
        <PC.CardWrapper>
            <PC.CardImg>
                <img src={image} alt={title}/>
                {advertiserName && advertiserErid &&
                    <NonStaticContainer
                        $united={{ $top: 0, $right: 0 }}
                    >
                        <AdvertisingLabelWithTooltip
                            companyName={advertiserName}
                            erid={advertiserErid}
                            tooltip={{
                                position: 'top-right',
                            }}
                        />
                    </NonStaticContainer>
                }
            </PC.CardImg>
            <PC.CardTitle>{title}</PC.CardTitle>
            <PC.CardDesc dangerouslySetInnerHTML={{ __html: body }}/>
        </PC.CardWrapper>
    );
};

export default PartnerCard;
